import {
  Box,
  CircularProgress,
  IconButton,
  Sheet,
  Table,
  Typography,
} from '@mui/joy';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { useUser } from '../../hooks/useUser';
import useBranches from '../../hooks/usebranches';

const Branches = () => {
  const branchesQuery = useBranches();
  const userQuery = useUser();

  if (!branchesQuery.isSuccess || !userQuery.isSuccess) {
    return <Typography>Loading...</Typography>;
  }

  if (userQuery.data.role !== 'SUPER_ADMIN') {
    return <Typography>Alleen super admins kunnen vestigingen beheren</Typography>;
  }

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography level="h4">Vestigingen</Typography>
        <IconButton
          size="sm"
          variant="outlined"
          color="neutral"
          onClick={() => branchesQuery.refetch()}
        >
          <RefreshRoundedIcon />
        </IconButton>
      </Box>

      <Typography level="body-sm" sx={{ mb: 2 }}>
        Deze pagina is alleen toegankelijk voor super admins
      </Typography>

      <Sheet variant="outlined" sx={{ borderRadius: 'sm', overflow: 'auto' }}>
        <Table stickyHeader>
          <thead>
            <tr>
              <th style={{ width: '100%' }}>
                <Typography level="title-sm" sx={{ fontWeight: 'bold' }}>
                  Naam vestiging
                </Typography>
              </th>
            </tr>
          </thead>
          <tbody>
            {branchesQuery.isFetching ? (
              <tr>
                <td>
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                    <CircularProgress size="sm" />
                  </Box>
                </td>
              </tr>
            ) : !branchesQuery.data.length ? (
              <tr>
                <td>
                  <Typography level="body-sm" sx={{ py: 2, textAlign: 'center' }}>
                    Nog geen vestigingen
                  </Typography>
                </td>
              </tr>
            ) : (
              branchesQuery.data.map((branch: any) => (
                <tr key={branch._id}>
                  <td>{branch.name}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Sheet>
    </>
  );
};

export default Branches;
